export default class MandatoryField {
    constructor() {
        const mandatoryFieldArray = document.querySelectorAll('.umbraco-forms-field.mandatory')
    
        mandatoryFieldArray.forEach(mandatoryField => {
            const fieldLabel = mandatoryField.querySelector('.umbraco-forms-label')
            fieldLabel.innerHTML = fieldLabel.innerHTML + " *"
        })
    }
}
